import { render, staticRenderFns } from "./ImportSave.vue?vue&type=template&id=f13e71b6&"
import script from "./ImportSave.vue?vue&type=script&lang=js&"
export * from "./ImportSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports